import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  { path: '/',          name: 'splash',        component: () => import('@/views/SplashView.vue'),        meta: { public: true } },
  { path: '/login',     name: 'login',         component: () => import('@/views/LoginView.vue'),         meta: { public: true } },
  { path: '/dashboard', name: 'dashboard',     component: () => import('@/views/DashboardView.vue') },
  { path: '/markets',   name: 'markets',       component: () => import('@/views/MarketsView.vue') },
  // Legacy /sector/:slug → redirect ไป /markets?sector=...
  { path: '/sector/:slug', redirect: (to) => ({ path: '/markets', query: { sector: String(to.params.slug) } }) },
  { path: '/search',    name: 'search',        component: () => import('@/views/SearchView.vue') },
  { path: '/stock/:symbol', name: 'stock-detail', component: () => import('@/views/StockDetailView.vue') },
  { path: '/watchlist', name: 'watchlist',     component: () => import('@/views/WatchlistView.vue') },
  { path: '/notifications', name: 'notifications', component: () => import('@/views/NotificationsView.vue') },
  { path: '/profile',   name: 'profile',       component: () => import('@/views/ProfileView.vue') },
  { path: '/portfolio', name: 'portfolio',     component: () => import('@/views/PortfolioView.vue') },
  { path: '/earnings-calendar', name: 'earnings-calendar', component: () => import('@/views/EarningsCalendarView.vue') },
  { path: '/indices', name: 'indices', component: () => import('@/views/IndicesView.vue') },
  { path: '/:catchAll(.*)', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, saved) {
    if (saved) return saved
    return { top: 0 }
  },
})

router.beforeEach((to) => {
  const auth = useAuthStore()
  if (to.meta.public) return true
  if (!auth.isAuthenticated) return { name: 'login' }
  return true
})

export default router
